// Main pages exports

// Core pages
// Optimized page exports for better code splitting and performance

// Lazy loaded components for better performance
import { lazy } from 'react';

// Core pages (loaded immediately)
export { default as HomePage } from './HomePage';

// Lazy loaded pages for better initial load performance with proper default handling
export const ServicesPage = lazy(() => 
  import('./services').then(module => ({ default: module.default || module }))
);
export const BookingPage = lazy(() => 
  import('./booking/BookingPage.jsx').then(module => ({ default: module.default }))
);
export const ProfilePage = lazy(() => 
  import('./profile').then(module => ({ default: module.default || module }))
);
export const AdminDashboardPage = lazy(() =>
  import('../admin').then(module => ({ default: module.AdminDashboardPage }))
);

// Category pages (lazy loaded with proper default handling)
export const CategoryPages = lazy(() => 
  import('./services/categories').then(module => ({ default: module.default || module }))
);

// Specific service pages (lazy loaded for better performance with proper default handling)
export const ServiceDetailsPage = lazy(() => 
  import('./services/ServiceDetailsPage.jsx').then(module => ({ default: module.default }))
);
export const NewServicePage = lazy(() => 
  import('./services/NewServicePage.jsx').then(module => ({ default: module.default }))
);
export const MostBookedServicesPage = lazy(() => 
  import('./services/MostBookedServicesPage.jsx').then(module => ({ default: module.default }))
);
export const RequestCustomServicePage = lazy(() => 
  import('./services/RequestCustomServicePage.js').then(module => ({ default: module.default }))
);

// Profile pages (lazy loaded with proper default handling)
export const PoojaDetailsPage = lazy(() => 
  import('./profile/PoojaDetailsPage.js').then(module => ({ default: module.default }))
);
export const PanditProfilePage = lazy(() => 
  import('./profile/PanditProfilePage.js').then(module => ({ default: module.default }))
);
export const PanditDashboardPage = lazy(() => 
  import('./profile/PanditDashboardPage.jsx').then(module => ({ default: module.default }))
);

// Booking pages (lazy loaded with proper default handling)
export const BookingConfirmationPage = lazy(() => 
  import('./booking/BookingConfirmationPage.jsx').then(module => ({ default: module.default }))
);
export const BookingSummaryPage = lazy(() => 
  import('./booking/BookingSummaryPage.js').then(module => ({ default: module.default }))
);

// Category-specific pages (lazy loaded with proper default export handling)
export const WeddingServicesPage = lazy(() => 
  import('./services/categories/WeddingServicesPage.jsx').then(module => ({ default: module.default }))
);
export const WeddingServicesPageModular = lazy(() => 
  import('./services/categories/WeddingServicesPageModular.jsx').then(module => ({ default: module.default }))
);
export const HomePoojaServicesPage = lazy(() => 
  import('./services/categories/HomePoojaServicesPage.jsx').then(module => ({ default: module.default }))
);
export const FestivalServicesPage = lazy(() => 
  import('./services/categories/FestivalServicesPage.jsx').then(module => ({ default: module.default }))
);
export const LifeEventsPage = lazy(() => 
  import('./services/categories/LifeEventsPage.jsx').then(module => ({ default: module.default }))
);
export const SpiritualServicesPage = lazy(() => 
  import('./services/categories/SpiritualServicesPage.jsx').then(module => ({ default: module.default }))
);
export const SpecialOccasionsPage = lazy(() => 
  import('./services/categories/SpecialOccasionsPage.jsx').then(module => ({ default: module.default }))
);

// Performance utility for preloading critical pages
export const preloadCriticalPages = () => {
  // Preload most commonly accessed pages
  import('./services');
  import('./booking');
  import('./services/categories/WeddingServicesPageModular');
};

// Error boundary for lazy loaded components
export const PageErrorBoundary = ({ children, fallback }) => {
  return (
    <div className="page-error-boundary">
      {children}
    </div>
  );
};

// Booking pages  
export * from './booking';

// Service pages
export * from './services';

// Profile pages
export * from './profile';

